// @flow
import React, { Component } from 'react'
import LabeledWrapper from './LabeledWrapper'
import { InputCell } from '../AudienceEdit'

type Props = {|
  label: string,
  value: string,
  errors: Array<string>,
  onChange: (string) => void
|}

export default class AudienceName extends Component<Props> {
  render() {
    const { label } = this.props
    return (
      <LabeledWrapper label={label} errors={this.props.errors} twoLines>
        <InputCell>
          <input
            type="name"
            id="audience_name"
            value={this.props.value}
            onChange={(event) => {
              this.props.onChange(event.target.value)
            }}
            className="input-item input-item_full-width"
          />
        </InputCell>
      </LabeledWrapper>
    )
  }
}
